import { useEffect, useState } from "react";

import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import InputGroup from "react-bootstrap/InputGroup";

import { Option } from "@/@types/generics/Option";

import { SelectComponent } from "@/components/SelectComponent";
import { AttendancesByCity } from "./AttendancesByCity";
import { NonSpecializedMedicalAttendances } from "./NonSpecializedMedicalAttendances";
import { SpecializedMedicalAttendances } from "./SpecializedMedicalAttendances";
import { MedicalAttendancesByCid } from "./MedicalAttendancesByCid";
import { Card } from "react-bootstrap";
import { useLayout } from "@/../_metronic/layout/core";

export function GeneralAttendances() {
	const { setTitle } = useLayout();
	const [selectedReportOption, setSelectedReportOption] = useState<number | undefined>();

	const reportOptions: Option<number>[] = [
		{ label: "Atendimentos na recepção por cidade", value: 1 },
		{ label: "Atendimentos médicos", value: 2 },
		{ label: "Atendimentos médicos especializados", value: 3 },
		{ label: "Atendimentos médicos por cid", value: 4 },
	];

	function renderReportComponent(reportOption?: number) {
		switch (reportOption) {
			case 1:
				return <AttendancesByCity />;
			case 2:
				return <NonSpecializedMedicalAttendances />;
			case 3:
				return <SpecializedMedicalAttendances />;
			case 4:
				return <MedicalAttendancesByCid />;
		}
	}

	useEffect(() => {
		setTitle("Listagem - Atendimentos");
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="p-4">
			<Card className="h-100 shadow-sm">
				<Card.Body>
					<Row className="p-2">
						<Col>
							<InputGroup>
								<Form.Label>Tipo de relatório</Form.Label>
								<SelectComponent
									className="w-100"
									name="generalattendances"
									options={reportOptions}
									onChange={(event) =>
										Boolean((event as Option<string>).value)
											? setSelectedReportOption(
													Number((event as Option<string>).value)
											  )
											: setSelectedReportOption(undefined)
									}
									defaultValue={{ value: "", label: "Escolha uma opção" }}
									noOptionsMessage={() =>
										"nenhum resultado encontrado na pesquisa"
									}
								/>
							</InputGroup>
						</Col>
					</Row>
					{renderReportComponent(selectedReportOption)}
				</Card.Body>
			</Card>
		</div>
	);
}
